<template>
  <el-drawer title="DOWNLOADS" :visible.sync="showList" :with-header="true">
    <div class="downloader">
      <ul class="header">
          <li style="width: 20px">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
          </li>
          <li style="width: 50px;"></li>
          <li style="width: 440px;text-align: left" v-if="downloadsList.length > 0"><span>File name</span></li>
          <li style="width: 440px;text-align: left" v-else><span>No files</span></li>
          <li>
            <el-tooltip
              class="item"
              effect="dark"
              content="Delete All"
              placement="left"
              v-if="downloadsList.length > 0"
            >
              <a class="black" @click="deleteAllFiles()">
                <span class="iconfont3 icon-delete font18"></span>
              </a>
            </el-tooltip>
          </li>
      </ul>
      <ul>
        <el-checkbox-group
          v-model="checkedDownloads"
          @change="handleCheckedDownloadsChange"
        >
          <div v-for="(file, index) of downloadsList" :key="index">
            <li style="width: 20px" >
              <el-checkbox :label="file._id"></el-checkbox>
            </li>
            <li style="width: 50px">
              <el-progress color="#000000" :show-text="true" :stroke-width="3" :width="35" type="circle" v-if="!isReady(file.filePath) && file.progress !== -1" :percentage="Math.round(file.progress) || 0"></el-progress>
              <i
                v-else-if="isReady(file.filePath)"
                :class="'iconfont3 icon-' + file.fileType + '_icon font30'"
              ></i>
              <i
                v-else-if="file.progress === -1"
                class="el-icon-error font30"
              ></i>
            </li>
            <li style="width: 440px;text-align: left">
              <a v-if="isReady(file.filePath)" @click="downloadFile(file._id)">
                {{ file.fileName }} ({{
                  parseFloat(file.fileSize / 1024).toFixed(2)
                }}
                KB)
              </a>
              <span v-else>{{ file.fileName }}</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="Delete"
                placement="left"
                v-if="isReady(file.filePath) || file.progress === -1"
              >
                <a class="black" @click="deleteFile(file._id)">
                  <span class="iconfont3 icon-delete font18"></span>
                </a>
              </el-tooltip>
            </li>
          </div>
        </el-checkbox-group>
      </ul>
      <button v-if="checkedDownloads.length > 0" type="button" class="el-button" @click="downloadSelected()">Download selected</button>
    </div>
  </el-drawer>
</template>
<style scoped>
.el-progress.el-progress--circle {
  height:100%;
  line-height:5.25;
}

.downloader {
  padding: 10px;
}
ul {
  list-style-type: none;
  padding-left: 10px;
}
ul.header{
  border-bottom: 1px solid gray;
}
ul li {
  vertical-align: middle;
  text-align: center;
  height:50px;
  color: black;
  display: inline-block;
}
ul li a {
  color: #337ab7;
  text-decoration: none;
  display: inline-block;
  line-height: 50px;
}
ul li .el-checkbox, ul li i, ul li span {
  line-height: 50px;
}
ul li span {
  color: black;
}
ul li {
  padding-bottom: 0px;
}
.v-spinner {
  display: inline-block;
  margin-right: 10px;
}
</style>
<script>
import axios from "axios";

export default {
  name: "Downloader",
  data() {
    return {
      checkedDownloads: [],
      checkAll: false,
      downloadsList: [],
      showList: false,
      myInterval: null,
      isIndeterminate: false,
      interval: null,
      DownloaderBroadCast : new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel())
    };
  },
  watch: {
    pendingDownloads(newVal, oldVal) {
      if (newVal.length > 0) {
        this.DownloaderBroadCast.postMessage({
          type: "pendingDownloads",
          value: newVal.length,
        });
        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.getDownloads, 2000);
        return;
      }
      if (oldVal.length > 0) {
        this.$message({
          type: "success",
          message:
            "Your file's' are ready for download. Please find them in the downloads section",
        });
        clearInterval(this.myInterval);
        this.DownloaderBroadCast.postMessage({ type: "noPendingDownloads" });
      }
    },
  },
  computed: {
    pendingDownloads() {
      return this.downloadsList.filter((file) => !this.isReady(file.filePath) && file.progress !== -1);
    },
  },
  methods: {
    downloadSelected() {
      this.interval = setInterval(this.downloadFileWithInterval, 300, [...this.checkedDownloads])
    },
    downloadFileWithInterval(downloads) {
      var downloadId = downloads.pop();

      this.downloadFile(downloadId)

      if (downloads.length == 0) {
        clearInterval(this.interval);
      }
    },
    handleCheckAllChange(val) {
      this.checkedDownloads = val
        ? this.downloadsList.map((file) => file._id)
        : [];
      this.isIndeterminate = false;
    },
    handleCheckedDownloadsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.downloadsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.downloadsList.length;
    },
    isReady(filePath) {
      if (typeof filePath != "undefined" && filePath != "") {
        return true;
      }
      return false;
    },
    openDownloadList() {
      this.showList = true;
    },

    async initiateDownload(fileType, fileName, data = null, id) {
      var o = {
        fileType: fileType,
        fileName: fileName || `temporary_file_name.${fileType}`,
        filePath: "",
        id: id
      };

      var response = await axios.post(
        this.$store.state.serverURL + "/downloads",
        {
          data: data,
          download: o,
        }
      );

      o._id = response.data._id;
      this.downloadsList.unshift(o);
    },
    async getDownloads() {
      var response = await axios.get(
        this.$store.state.serverURL + "/downloads/"
      );
      this.downloadsList = response.data;
    },
    downloadFile(fileId) {
      var a = document.createElement("a");
      a.href = this.$store.state.serverURL + "/downloads/" + fileId;
      a.setAttribute("download", '')
      a.click();
    },
    async deleteFile(fileId) {
      try {
        await axios.delete(
          this.$store.state.serverURL + "/downloads/" + fileId
        );
      } catch (err) {
        this.$message({
          type: "error",
          message: err.response.data.msg,
        });
        return;
      }
      this.$message({
        type: "success",
        message: "File successfully removed!",
      });
      this.getDownloads();
    },
    async deleteAllFiles() {
      try {
        await axios.delete(this.$store.state.serverURL + "/downloads");
      } catch (err) {
        this.$message({
          type: "error",
          message: err.response.data.msg,
        });
        return;
      }
      this.$message({
        type: "success",
        message: "All files successfully removed!",
      });
      this.getDownloads();
    },
    async doesExists(id) {
      var r = false;
        for(var download of this.downloadsList) {
          if (download.id == id) {
            await this.$confirm("You already have generated file in your downloads list for this resource? Do you want to generate it again?", "Warning", {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning"
            }).then(() => {
              r = false;
            }).catch(() => {
              r = true;
            });
            return r;
          } 
        }
        return false;
    }
  },
  async mounted() {
    this.DownloaderBroadCast.onmessage = async (event) => {
      if (event.data.type == "initiateDownload" && !await this.doesExists(event.data.id) ) {
          this.initiateDownload(
            event.data.fileType,
            event.data.fileName,
            event.data.data,
            event.data.id
          );
      } else if (event.data.type == "openDownloadList") {
        this.openDownloadList();
      }
    };

    await this.getDownloads();
  },
};
</script>